import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

import { SubmissionButton } from "@thalamos/frontend";

import { PopupDialog } from "../../Dialog/PopupDialog.js";

export interface DeleteUserDirectoryInstanceModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  orgName: string;
}

export function DeleteUserDirectoryInstanceModal({
  open,
  onClose,
  onConfirm,
  orgName,
}: DeleteUserDirectoryInstanceModalProps) {
  const { t } = useTranslation();
  return (
    <PopupDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableDialogRootPadding={true}
    >
      <DialogTitle>
        {t("admin.userDirectoryInstances.deleteInstance")}
      </DialogTitle>
      <DialogContent>
        <Typography>
          <Trans
            i18nKey="admin.userDirectoryInstances.deleteInstanceAreYouSure"
            values={{ orgName }}
            components={{ 1: <strong /> }}
          />
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          px: 3,
        }}
      >
        <Button onClick={onClose} color="error" variant="outlined">
          {t("common.close")}
        </Button>

        <SubmissionButton
          onClick={onConfirm}
          color="primary"
          variant="contained"
        >
          {t("admin.userDirectoryInstances.delete")}
        </SubmissionButton>
      </DialogActions>
    </PopupDialog>
  );
}
